import { Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { formatDollarsFromCents } from 'utilities/helpers';
import { formatDate } from 'utilities/datesAndTimes';
import { getDefaultPayments, getPaymentPlanEndDate } from './offerHelpers';

const { Text } = Typography;

export const getStartDateText = (startDate) =>
  startDate
    ? `With a first payment date of ${formatDate(dayjs(startDate))}`
    : 'With a start date of today';

const EstimatedPaymentsBreakdown = ({
  amount,
  durationMonths,
  expirationDate,
  startDate,
  intro,
}) => {
  const estimateStart = startDate ? dayjs(startDate) : dayjs();
  const payments = getDefaultPayments({
    amount,
    startDate: estimateStart,
    endDate: getPaymentPlanEndDate(
      estimateStart,
      durationMonths,
      expirationDate,
    ),
    durationMonths,
  });

  const displayAmount = (value) =>
    value == null ? '--' : formatDollarsFromCents(value);

  return (
    <Text>
      {intro ?? (
        <>
          <CalendarOutlined /> <strong>{getStartDateText(startDate)},</strong> a
          customer would owe about:
        </>
      )}
      <br />
      <strong>{displayAmount(payments.monthly)} | monthly</strong>, over{' '}
      {durationMonths} months
      <br />
      <strong>{displayAmount(payments.biweekly)} | every 2 weeks</strong>, over{' '}
      {durationMonths} months
      <br />
      <strong>{displayAmount(payments.weekly)} | weekly</strong>, over{' '}
      {durationMonths} months
    </Text>
  );
};

export default EstimatedPaymentsBreakdown;
